import { configureStore } from '@reduxjs/toolkit'
import { clientApi } from 'actions/client/client-api'
import { clientAccountApi } from 'actions/client/client-account-api'
import { clientFacilityApi } from 'actions/client/client-facility-api'
import { clientDosemeterMeasurementApi } from 'actions/client/client-dosemeter-measurement-api'
import { userApi } from 'actions/admin-user-api'
import { translationApi } from 'actions/translation-api'
import currentUserReducer from 'store/admin-user/reducer.user-get-current'
import translationsReducer from 'store/admin-translation/reducer.translations'
import clientListFilter from 'store/client/slice.client-list-filter'
import clientListReducer from 'store/client/reducer.client-list'
import clientReducer from 'store/client/reducer.client-get'
import newClientReducer from 'store/client/reducer.client-get-new'
import addClientReducer from 'store/client/reducer.client-add'
import saveClientReducer from 'store/client/reducer.client-save'
import accountListFilter from 'store/client/slice.account-list-filter'
import facilityListFilter from 'store/client/slice.facility-list-filter'
import measurementListFilter from 'store/client/slice.measurement-list-filter'
import measurementReportListFilter from 'store/client/slice.measurement-report-list-filter'

const store = configureStore({
	reducer: {
		[clientApi.reducerPath]: clientApi.reducer,
		[clientAccountApi.reducerPath]: clientAccountApi.reducer,
		[clientFacilityApi.reducerPath]: clientFacilityApi.reducer,
		[clientDosemeterMeasurementApi.reducerPath]: clientDosemeterMeasurementApi.reducer,
		[userApi.reducerPath]: userApi.reducer,
		[translationApi.reducerPath]: translationApi.reducer,
		currentUserReducer, translationsReducer,
		clientListFilter,
		clientListReducer, newClientReducer, clientReducer, addClientReducer, saveClientReducer,
		accountListFilter,
		facilityListFilter,
		measurementListFilter,
		measurementReportListFilter,
	},
	middleware: getDefaultMiddleware => getDefaultMiddleware().concat([
		clientApi.middleware,
		clientAccountApi.middleware,
		clientFacilityApi.middleware,
		clientDosemeterMeasurementApi.middleware,
		userApi.middleware,
		translationApi.middleware
	])
});
export default store;
